import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
export const ENUM = {

};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-identifier',
  icon: 'text-field',
  label: '自动编号',
  formItemFlag: true,
  component: require('./index.vue').default,
  props() {
    const props = {
      setting: () => import('./setting.vue')
    };
    return props;
  },
  options: {
    name: '',
    label: '自动编号',
    requiredHint: ' ',
    labelHidden: false,
    labelWidth: '',
    required: false,
    labelWrap: false, // 自动换行
    position: '',
    labelAlign: '',
    placeholder: '系统自动生成编号',
    columnWidth: '200px',
    // ----
    setting: '', // 组件引用专用字段
    ruleId: '',
    tableName: '',
    // ----
    customClass: '',
    onValidate: '',
    onMounted: '',
    onChange: '',
    onInitAndUpdate: ""
  },
  setDesign: {
    businessNoList: ({ options: { name: fieldName, ruleId, tableName }}) => (
      { fieldName, ruleId, tableName }
    )
  }
};
